module.exports = __webpack_public_path__ + "img/price-banner-xs.e800254c.png";